module.exports = {
  app_url: process.env.REACT_APP_APP_URL ?? "",
  product: "connect",
  api_url: process.env.REACT_APP_API_URL
    ? process.env.REACT_APP_API_URL
    : "http://localhost",
  api_version: 5,
  customer: process.env.REACT_APP_CUSTOMER,
  sentry_env: process.env.REACT_APP_SENTRY_ENV,
  sentry_dsn: process.env.REACT_APP_SENTRY_DSN,
  zapier_invite_url:
    process.env.REACT_APP_ZAPIER_INVITE_URL ??
    "https://zapier.com/developer/public-invite/191635/b8f751486fd785ee805a3df1abd1be21/",
  privacy_policy_url: "https://cosoft.co.uk/connect-privacy-policy/",
  click_to_dial_extension_id:
    process.env.REACT_APP_CTD_EXTENSION_ID ??
    "joolkfmijoplolnckgdicbnijjjmhdlm",
  network_detail_allowed_urls: [
    "https://one4.ipecs-cloud.co.uk",
    "https://onelab2.ipecs-cloud.co.uk",
    "https://ipecsone.focus-grp.co.uk",
    "https://one1.ipecs-cloud.co.uk",
    "https://one2.ipecs-cloud.co.uk",
    "https://ipecsone.cloudvoice.ie",
    "https://one.smarticloud.it",
    "https://one1.ipecscloud.com.au",
    "https://one3.ipecs-cloud.co.uk",
    "https://onelab2.ipecscloud.com.au",
    "https://ipecsone.ariacloud.co.za",
    "https://one.yellowcom-cloud.co.uk",
    "https://one.adept-nebula.co.uk",
  ],
};
